module.exports = __webpack_public_path__ + "img/chubriki.01c0ffb4.png";